// extracted by mini-css-extract-plugin
export default {"success":"success_success__t5Nc6","successImage":"success_successImage__rlQyY","successText":"success_successText__trLMf"};